<svg enable-background="new 0 0 100 100" id="Layer_1" version="1.1" viewBox="0 0 100 100" x="0px"
     xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px" *ngIf="loader">
  <defs>
    <linearGradient
      [attr.x1]="loader.linearGradientPosition.x1"
      [attr.x2]="loader.linearGradientPosition.x2"
      [attr.y1]="loader.linearGradientPosition.y1"
      [attr.y2]="loader.linearGradientPosition.y2"
      id="linear">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </linearGradient>
    <radialGradient [attr.fx]="loader.radialGradientPosition.x"
                    [attr.fy]="loader.radialGradientPosition.y"
                    id="radial">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </radialGradient>
  </defs>
  <rect [attr.fill]="loader.color" height="100" transform="translate(0) rotate(180 3 50)" width="3">
  <animate
    attributeName="height"
    attributeType="XML"
    dur="1s"
    repeatCount="indefinite"
    values="30; 100; 30"/>
</rect>
  <rect [attr.fill]="loader.color" height="100" transform="translate(0) rotate(180 20 50)" width="3" x="17">
  <animate
    attributeName="height"
    attributeType="XML"
    begin="0.1s"
    dur="1s"
    repeatCount="indefinite"
    values="30; 100; 30"/>
</rect>
  <rect [attr.fill]="loader.color" height="100" transform="translate(0) rotate(180 40 50)" width="3" x="40">
  <animate
    attributeName="height"
    attributeType="XML"
    begin="0.3s"
    dur="1s"
    repeatCount="indefinite"
    values="30; 100; 30"/>
</rect>
  <rect [attr.fill]="loader.color" height="100" transform="translate(0) rotate(180 58 50)" width="3" x="60">
  <animate
    attributeName="height"
    attributeType="XML"
    begin="0.5s"
    dur="1s"
    repeatCount="indefinite"
    values="30; 100; 30"/>
</rect>
  <rect [attr.fill]="loader.color" height="100" transform="translate(0) rotate(180 76 50)" width="3" x="80">
  <animate
    attributeName="height"
    attributeType="XML"
    begin="0.1s"
    dur="1s"
    repeatCount="indefinite"
    values="30; 100; 30"/>
</rect>
</svg>
